<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <div class="flex flex-row">
      <div class="basis-full">
        <drdp-title
          [title]="
            t('manageEnrollment.students.pageTitle', {
              classroom:
                classroomName ??
                t('manageEnrollment.students.classroomNameNotFound')
            })
          "
        ></drdp-title>
        <h2 class="pb-5">
          {{
            t('manageEnrollment.students.ratingPeriodLabel', {
              ratingPeriod:
                ratingPeriodName ??
                t('manageEnrollment.students.ratingPeriodNotFound')
            })
          }}
        </h2>
        <div class="flex justify-end py-3">
          <drdp-btn
            color="cancel"
            class="mr-3"
            mat-button
            type="button"
            (click)="onCancel()"
          >
            {{ t('manageEnrollment.myClasses.actions.cancel') }}
          </drdp-btn>
          <drdp-btn mat-button type="submit" (click)="onSave()" cdkFocusInitial>
            {{ t('manageEnrollment.bulkUnEnroll.withdrawBatch') }}
          </drdp-btn>
        </div>
      </div>
    </div>

    <drdp-container>
      <div class="w-full">
        <div class="text-blue-600 cursor-pointer" (click)="selectAll()">
          {{ t('manageEnrollment.bulkUnEnroll.selectAll') }}
        </div>
        <drdp-add-edit-table
          (toggleSwitchActionItem)="handleSelectedChild($event)"
          [dataSource]="dataSource"
          [tableData]="tableData"
          [columns]="tableColumns"
        >
        </drdp-add-edit-table>
      </div>
    </drdp-container>
  </div>

  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [length]="totalData"
    [pageIndex]="pageIndex"
    (page)="paginate()"
  >
  </mat-paginator>
</ng-container>
